module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Reader",
      "epub:type": "backmatter"
    }
  }, [_c('p', {
    staticClass: "noindent3"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page viii. ",
      "epub:type": "pagebreak",
      "id": "pg_viii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("My elders say not long ago we were able to blend into our environment the way animals do. Like bears we could step into the brush and vanish from sight. The ability arose from something deep within us, blood instinct and survival, the oldest kind of knowledge. When guns and horses gave advantage over our enemies, we no longer needed innate camouflage. The more interaction we had with the unnatural world, the less we relied on our instinctual abilities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('i', [_vm._v("The Lost Journals of Sacajewea")]), _vm._v(", communication is Sacajewea’s hold on the instinctual. Language is her digging stick to memory, her song, her tap-tapping into old knowledge in order to survive. Sounds are alive to her. Instead of ellipses I use two or more successive periods— . . —to indicate pauses. These periods are her heart and drum beats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The double periods— . . —also suggest stuttered awe when she witnesses events that are inviolable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She believes that written and spoken words can manifest the “thing” itself. For that reason, sacred names, ideas, or words that should not be uttered are italicized and appear faded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When people are significant or require negotiation and/or deference, names are capitalized. Sacajewea determines the hierarchal relationship to the people and animals around her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("History has long been translated by the powerful, so Sacajewea’s translations and transfigurations become her power. She captures the living breath through sound. Nouns become verbs. Verbs become vibrations. Punctuation echoes natural pauses. People are re-remembered through the lens of trauma and loss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the precipice of colonization she finds emancipation through her own peculiar language. Lines are shattered to reveal spiritual expansiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page ix. ",
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The woman known as Sacajawea by the Lemhi Shoshone appears only a handful of times in the voluminous journals of Lewis and Clark. Her name—and later her tribal identity—her marriage, her age, the date of her death, even her role in the expedition as interpreter, guide, or friendly talisman to ward off hostile tribes is fraught. An enslaved young girl traveling with a military expedition spoils the long held notion that the expedition was wholesome.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet, two hundred years after the Lewis and Clark Expedition the “historical” Sacajawea codifies an account that does not sully the discovery narrative. She does not speak. She does not fight back in visible ways. She participates. Or does she?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("The Lost Journals of Sacajewea")]), _vm._v(" is a fictional account of the life of Sacajawea. Her story, like all human stories, is sacrosanct, but her story remains an undeniable testament to the power of cultural knowledge and resistance. Sacajawea survived what many could not.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("DME")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_vm._v("November 28, 2022")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5060ebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/reader.vue
// module id = 69
// module chunks = 0